import { FC } from "react";
import { Divider, Form } from "antd";
import { InputChip } from "src/components";
import { INPUT_CHIP_PROPS, PASSENGER_TYPES, INITIAL_PASSENGERS, PassengersType } from "../../../constants";
import { applyPassengerTransformations, validatePassengers } from "../PassengerSelection/utils";

type PassengersProps = {
  value?: PassengersType;
  onChange?: (value: PassengersType) => void;
};

const Passengers: FC<PassengersProps> = ({ value = INITIAL_PASSENGERS, onChange }) => {
  const handleChange = (key: keyof PassengersType) => (val: number | null) => {
    if (val === null) return;
    const updatedPassengers = applyPassengerTransformations(value, key, val);
    if (!validatePassengers(updatedPassengers)) return;
    onChange?.(updatedPassengers);
  };

  const getMax = (key: keyof PassengersType, max?: number) => {
    const canIncrement = validatePassengers(applyPassengerTransformations(value, key, value[key] + 1));
    return canIncrement ? (max ?? INPUT_CHIP_PROPS.max) : value[key];
  };

  return (
    <div className="flex flex-col gap-5 p-3 w-full">
      {PASSENGER_TYPES.map(({ key, label, subLabel, min, max }) => (
        <InputChip
          key={key}
          label={label}
          subLabel={subLabel}
          {...INPUT_CHIP_PROPS}
          value={value[key]}
          onChange={handleChange(key)}
          min={min ?? INPUT_CHIP_PROPS.min}
          max={getMax(key, max)}
          classNames={{
            actions: ["hover:text-font-active disabled:text-font-disabled", "hover:text-font-active disabled:text-font-disabled"],
          }}
        />
      ))}
    </div>
  );
};

export default function PassengerSelectContent() {
  return (
    <Form.Item name="passengers" className="m-0!">
      <Passengers />
    </Form.Item>
  );
}
